import { MSG_NEGATIVE_VALUES, MSG_EXCEEDS_TICKET_LIMIT } from "../../../../utils/messages";

export const validateDonationForm = (values) => {
    let errors = {};

    if (0 > Number(values.tickets)) {
        errors.tickets = MSG_NEGATIVE_VALUES;
    } else if (Number(values.ticketLimit) < Number(values.tickets)) {
        errors.tickets = MSG_EXCEEDS_TICKET_LIMIT + ` (${values.ticketLimit})`;
    }

    return errors;

}